// extracted by mini-css-extract-plugin
export default {"box":"file-without-preview_box__KhCqv","download":"file-without-preview_download__X3wsk","pdfIcon":"file-without-preview_pdfIcon__fTmVL"};